import axios from 'axios';

export default {
  fetchNotes({
    commit,
  }, params) {
    commit('setLoading', true);
    commit('setError', false);
    console.log(params);
    const { parentResource, parentResourceId } = params;
    let uri = '/';

    if (parentResource && parentResourceId) {
      uri += `${parentResource}/${parentResourceId}/`;
    }
    uri += 'note';
    console.log(`URI: ${uri}`);

    return axios.get(uri, {
      params,
    })
      .then((notes) => {
        commit('setData', notes);
      })
      .catch((err) => {
        commit('setError', err);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
  saveNotes(_, params) {
    return axios.post('/note', params);
  },
  saveNote(_, params) {
    return axios.post('/note', params);
  },
};
